import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "size", "placeholderWidth", "children"];
import React, { forwardRef } from 'react';
import { hasReactChildren } from 'utils/ui';
import Text from 'components/Text';
import TextPlaceholder from 'components/TextPlaceholder';
export var HEADING_SIZES = {
  'extra-small': ['m', 'm'],
  small: ['m', 'l'],
  medium: ['l', 'xl'],
  large: ['xl', 'xxl']
};

/**
 * Unlike most of our polymorphic components, for headings
 * we want to make the `as` prop required so that we don't
 * forget to set the correct heading level for it and if we
 * do, it's more obvious :) ).
 */

var Heading = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var as = _ref.as,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    placeholderWidth = _ref.placeholderWidth,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var hasChildren = hasReactChildren(children);
  return (
    /*#__PURE__*/
    /*
    Warning!!! This instance of `Text`
    is currently not typechecked properly.
    Comment out `otherProps` and `as` when
    making changes to check types
             */
    React.createElement(Text, _extends({
      bold: true,
      ref: ref,
      as: as,
      overflow: "wrap",
      size: HEADING_SIZES[size],
      lineHeight: 1.25,
      breakpoints: "m"
    }, otherProps), hasChildren ? children : /*#__PURE__*/React.createElement(TextPlaceholder, {
      width: placeholderWidth
    }))
  );
});
Heading.displayName = 'Heading';
export default Heading;